module.exports = __webpack_public_path__ + "img/SocialFeed.86123119.png";